import './settings-leaf.css';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../ui.tsx';
import { CardSaveFooter, useCompanyCardForm } from './company-card-form.tsx';
import type { Company } from '@shared/types/index.ts';

/**
 * The prefixes new quote and invoice numbers start with. Once a disclosure at
 * the foot of the pricing card; its own destination now, so it saves on its
 * own and a prefix error shows beside the field that caused it.
 */

const snapshot = (company: Company) => ({
  quoteNumberPrefix: company.quoteNumberPrefix,
  invoiceNumberPrefix: company.invoiceNumberPrefix,
});

const toPayload = (draft: ReturnType<typeof snapshot>) => draft;

export default function NumberingCard() {
  const { t } = useTranslation();
  const form = useCompanyCardForm(snapshot, toPayload);

  const draft = form.draft;
  if (!draft) return null;

  return (
    <section className="card work-section settings-leaf mb-6" aria-labelledby="numbering-heading">
      <div className="work-section-heading">
        <h2 id="numbering-heading" className="mb-4 text-lg font-semibold">
          {t('settings.numberingHeading')}
        </h2>
      </div>
      <p className="mb-4 text-sm text-[color:var(--color-muted)]">{t('settings.numberingDescription')}</p>

      <div className="grid gap-x-4 sm:grid-cols-2">
        <TextInput
          label={t('settings.quoteNumberPrefix')}
          hint={t('settings.quoteNumberPrefixHint')}
          value={draft.quoteNumberPrefix}
          disabled={form.readOnly}
          error={form.fieldErrors.quoteNumberPrefix}
          onChange={(event) => form.set('quoteNumberPrefix', event.target.value)}
        />
        <TextInput
          label={t('settings.invoiceNumberPrefix')}
          hint={t('settings.invoiceNumberPrefixHint')}
          value={draft.invoiceNumberPrefix}
          disabled={form.readOnly}
          error={form.fieldErrors.invoiceNumberPrefix}
          onChange={(event) => form.set('invoiceNumberPrefix', event.target.value)}
        />
      </div>

      <CardSaveFooter form={form} saveLabel={t('settings.saveNumbering')} />
    </section>
  );
}
